var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.491,
    height: 16.491,
    viewBox: "0 0 16.491 16.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.595-4.913,19.8-3.123,13.33-9.6,6.894-3.123,5.1-4.913l6.475-6.437L5.1-17.824l1.79-1.79L13.33-13.14,19.8-19.614l1.79,1.79L15.12-11.35Z",
    transform: "translate(-5.104 19.614)",
    fill: "#203a59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceClose);
export default __webpack_public_path__ + "static/media/service_close.4753758addd6b7393def145a2c4f77d2.svg";
export { ForwardRef as ReactComponent };